import { api } from "../common/http";

const toPage = (res) => res.data;

const AgentBalanceLedgerApi = {
  list: async ({
    page = 0,
    size = 20,
    sort = "createdAt,desc",
    q,
    agentId,
    country,
    currency,
    type,        
    txUuid,
    from,        
    to,          
  } = {}) => {
    const params = { page, size, sort };
    if (q) params.q = q;
    if (agentId != null) params.agentId = agentId;
    if (country) params.country = country;
    if (currency) params.currency = currency;
    if (type) params.type = type;
    if (txUuid) params.txUuid = txUuid;
    if (from) params.from = from;
    if (to) params.to = to;

    const res = await api.get("/agent-balances/ledger", { params });
    return toPage(res);
  },

  getById: async (id) => (await api.get(`/agent-balances/ledger/${id}`)).data,

  listByTxUuid: async (txUuid, { page = 0, size = 20, sort = "createdAt,desc" } = {}) => {
    const params = { page, size, sort };
    const res = await api.get(`/agent-balances/ledger/by-tx/${txUuid}`, { params });
    return toPage(res);
  },

  listByAgentId: async (agentId, { page = 0, size = 20, sort = "createdAt,desc" } = {}) => {
    const params = { page, size, sort };
    const res = await api.get(`/agent-balances/ledger/by-agent/${agentId}`, { params });
    return toPage(res);
  },
};

export default AgentBalanceLedgerApi;
